import { appConfig } from 'logic/appConfigProvider';

export function isKpn() : boolean {
    return appConfig.skin === 'kpn'; 
}